<template>
  <page-view>
    <about-section
      :heading="$t('about')"
      :title="$t('aboutTitle')"
      :title-author="$t('aboutTitleAuthor')"
      :title-author-link="$t('aboutTitleAuthorLink')"
      :content="$t('aboutContent')"
    />
    <projects-section
      :heading="$t('projectCategories')"
      :projects="projects"
    />
    <consultancy-section
      :heading="$t('aboutConsultancyTitle')"
      :content="$t('aboutConsultancyContent')"
      :photo="consultancy.photo"
    />
    <trust-section
      :heading="$t('trustedUs')"
      :customers="customers"
      :customers2="customers2"
    />
  </page-view>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import AboutSection from '@/containers/About/AboutSection'
import ProjectsSection from '@/containers/About/ProjectsSection'
import ConsultancySection from '@/containers/About/ConsultancySection'
import TrustSection from '@/containers/About/TrustSection'

export default {
  components: {
    AboutSection,
    ProjectsSection,
    ConsultancySection,
    TrustSection
  },
  data () {
    return {
      consultancy: {
        photo: '/img/sawawa_directors.jpg'
      }
    }
  },
  computed: {
    ...mapGetters(['customers', 'customers2']),
    projects () {
      return [
        {
          title: this.$t('aboutStudiesTitle'),
          description: this.$t('aboutStudiesDescription')
        },
        {
          title: this.$t('aboutAnalysisTitle'),
          description: this.$t('aboutAnalysisDescription')
        },
        {
          title: this.$t('aboutPlanningTitle'),
          description: this.$t('aboutPlanningDescription')
        },
        {
          title: this.$t('aboutPublicTitle'),
          description: this.$t('aboutPublicDescription')
        },
        {
          title: this.$t('aboutArchitectureTitle'),
          description: this.$t('aboutArchitectureDescription')
        },
        {
          title: this.$t('aboutEvaluationTitle')
        }
      ]
    }
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('fetchCustomers')
      .then(() => store.dispatch('fetchCustomers2'))
      .then(next)
      .catch(() => {
        next({ name: 'home' })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/About/AboutContainer.vue